const axios = require("axios");
let isDebug = false;
function getRequestBargainUrl() {
  var tmpHost = location.hostname;
  var url = "";
  if (/-dev|localhost|^192|^172/.test(tmpHost)) {
    url = "https://mp-stg.huolala.cn/lala-mall/api";
    isDebug = true;
  } else if (/-stg/.test(tmpHost)) {
    url = "https://mp-stg.huolala.cn/lala-mall/api";
    isDebug = true;
  } else if (/-pre/.test(tmpHost)) {
    url = "https://mp-pre.huolala.cn/lala-mall/api";
    isDebug = true;
  } else {
    url = "https://mp.huolala.cn/lala-mall/api";
    isDebug = false;
  }
  return url;
}
let requestLalaUrl = getRequestBargainUrl();
export const init_wx = (shareImg = "") => {
  let url = encodeURIComponent(location.href.split("#")[0]);
  let hrefUrl = window.location.href;
  axios
    .get(`${requestLalaUrl}/wx/js/sdk/signature?url=${url}`)
    .then(function(res) {
      if (res.data.code === 0) {
        let resultData = res.data.data;
        wx.config({
          debug: isDebug, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: resultData.appId, // 必填，公众号的唯一标识
          timestamp: resultData.timestamp, // 必填，生成签名的时间戳
          nonceStr: resultData.noncestr, // 必填，生成签名的随机串
          signature: resultData.signature, // 必填，签名
          jsApiList: [
            "updateAppMessageShareData",
            "updateTimelineShareData",
            "scanQRCode"
          ], // 必填，需要使用的JS接口列表
          openTagList: ["wx-open-launch-weapp"]
        });
      }
    });

  wx.ready(function() {
    const btn = document.getElementById("launch-btn");
    btn.addEventListener("launch", function(e) {});
    btn.addEventListener("error", function(e) {
      console.log("fail", e.detail);
    });

    console.log("wx-ready   success");
    wx.updateAppMessageShareData({
      title: "租买货车，就找货拉拉", // 分享标题
      desc: "车型多，价格低，方案灵活！立即预约优惠！", // 分享描述
      link: hrefUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: shareImg, // 分享图标
      success: function() {
        console.log("分享成功");
        // 设置成功
      }
    });
    wx.updateTimelineShareData({
      title: "租买货车，就找货拉拉", // 分享标题
      link: hrefUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: shareImg, // 分享图标
      success: function() {
        console.log("分享成功");
        // 设置成功
      }
    });
  });
};
